<nz-form-item>
  <nz-form-control [nzValidateStatus]="onValidation ? 'validating' : errorType" [nzErrorTip]="errorMessage">
    <nz-radio-group [id]="code" [(ngModel)]="value" (ngModelChange)="inputChanged()">
      <ng-container *ngFor="let option of options">
        <label nz-radio *ngIf="isEnabled(option.fieldOptionId)" [nzValue]="option.fieldOptionId">
          {{ option.fieldOptionValue }}
        </label>
      </ng-container>
    </nz-radio-group>
  </nz-form-control>
</nz-form-item>